export const tooltip = 100;
export const chatbot = 1000;
export const modal = 10000;
